import { render, staticRenderFns } from "./postsProfile.vue?vue&type=template&id=d35d5258&scoped=true&"
import script from "./postsProfile.vue?vue&type=script&lang=js&"
export * from "./postsProfile.vue?vue&type=script&lang=js&"
import style0 from "./postsProfile.vue?vue&type=style&index=0&id=d35d5258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35d5258",
  null
  
)

export default component.exports